import React, { useState } from 'react';
import DashboardTemplate from 'src/templates/DashboardTemplate';
import { Button, Form, Input } from 'antd';
import { isValidCron } from 'cron-validator';
import { useForm } from 'antd/es/form/Form';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { usePostPeriodicityMutation } from 'src/redux/services/centralApi';
import { Cron } from 'react-js-cron';
import { FinalCronExpression } from 'src/pages/cron/AddCronPage/styles';

import 'react-js-cron/dist/styles.css';
import BRAZIL_LOCALE from 'src/pages/cron/AddCronPage/i18n';
import dayjs from 'dayjs';
interface ICronForm {
	alias: string;
	cron: string;
}

export default function AddCronPage() {
	const [ addCronForm, ] = useForm<ICronForm>();
	const [ cron, setCron, ] = useState('0 0 * * *');

	const [ postPeriodicity, postPeriodicityResult, ] =
        usePostPeriodicityMutation();

	const navigate = useNavigate();

	const isCronEveryMinute = () => {
		const [ minute, hour, day, month, week, ] = cron.split(/\s*/g);
		return hour === '*' && day === '*' && month === '*' && week === '*' && minute === '*';
	};

	const onAddCronFormFinish = (data: ICronForm) => {
		if(!isValidCron(cron)){
			toast.error('A expressão cron está inválida ou incompleta!');
			return;
		}

		if(isCronEveryMinute()){
			toast.error('O intervalo cron não pode ser a todo minuto!');
			return;
		}
		
		const creation_date = dayjs().format('YYYY-MM-DD');
		postPeriodicity({
			alias: data.alias,
			cron_expression: cron,
			creation_date,
		})
			.unwrap()
			.then(() => {
				addCronForm.resetFields();
				navigate('/cron/listar');
				toast.success('Cron adicionado com sucesso!');
			})
			.catch(() => {
				toast.error('Erro ao adicionar cron!');
			});
	};

	return (
		<DashboardTemplate pageTitle="Adicionar Cron">
			<Form
				onFinish={onAddCronFormFinish}
				layout="vertical"
				form={addCronForm}
			>
				<Form.Item
					required
					tooltip={
						<>Define o nome do cron que será exibido no sistema.</>
					}
					hasFeedback
					label="Apelido"
					name="alias"
					rules={[
						{
							min: 2,
							message:
                                'O apelido deve ter no mínimo 2 caracteres!',
						},
						{
							max: 50,
							message:
                                'O apelido deve ter no máximo 50 caracteres!',
						},
						{ required: true, message: 'Campo obrigatório.', },
					]}
				>
					<Input placeholder="Digite o apelido" />
				</Form.Item>
				<Form.Item
					required
					tooltip={
						<>
                            Define a expressão cron de acordo com o formato{' '}
							<Link
								target="_blank"
								to={'https://crontab.cronhub.io/'}
							>
                                unix
							</Link>
                            . O intervalo da expressão deve ser maior que 30 minutos.
						</>
					}
					label="Expressão Cron"
				>
					<Cron
						clearButton={cron !== '0 * * * *'}
						clearButtonAction="fill-with-every"
						allowedPeriods={[
							'day',
							'hour',
							'month',
							'week',
							'year',
						]}
						dropdownsConfig={{
							minutes: {
								allowClear: false,
								mode: 'single',
							},
						}}
						locale={BRAZIL_LOCALE}
						value={cron}
						setValue={(newValue: string) => {
							if (newValue === '* * * * *') {
								setCron('0 * * * *');
							} else {
								setCron(newValue);
							}
						}}
					/>
					<FinalCronExpression>{cron}</FinalCronExpression>
				</Form.Item>
				<Form.Item>
					<Button
						loading={postPeriodicityResult.isLoading}
						type="primary"
						htmlType="submit"
					>
                        Adicionar
					</Button>
				</Form.Item>
			</Form>
		</DashboardTemplate>
	);
}
